import styled from "styled-components";

export const Container = styled.section`
  width: 100%;
  overflow-x: hidden;
`;

// 공통
export const CommonTitle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 30px;
`;

export const CommonUnderBar = styled.div`
  border-top: 5px solid #3bb77e;
  width: 70px;
  margin-top: 15px;
`;

export const HeadWrapper = styled.section`
  text-align: center;
  word-break: keep-all;
  & p {
    color: #343a40;
    line-height: 3;
    font-size: 18px;
    @media screen and (max-width: 991px) {
      line-height: 2;
    }
  }
  & span {
    margin-left: 10px;
    color: #3bb77e;
  }
  margin-bottom: 75px;
`;

export const BodyWrapper = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ImgWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 150px;
`;

export const DescWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  border-left: 5px solid #3bb77e;
  padding-left: 30px;
  margin-bottom: 150px;
  word-break: keep-all;
  & span {
    color: #3bb77e;
  }

  @media screen and (max-width: 991px) {
    margin-bottom: 50px;
    & h4 {
      font-size: 20px;
    }
  }
  @media screen and (max-width: 767px) {
    & h4 {
      font-size: 18px;
    }
  }
  @media screen and (max-width: 575px) {
    & h4 {
      font-size: 16px;
    }
  }
`;

export const CardWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const CardRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 150px;
  & img {
    margin-right: 20px;
  }

  > div {
    display: flex;
    flex-direction: column;
    & h2 {
      margin-bottom: 100px;
    }

    & p {
      margin-bottom: 50px;
      word-break: keep-all;
    }

    & a {
      background-image: url("/assets/imgs/page/esg/esg_btn_off.png");
      background-position: center;
      background-repeat: no-repeat;
      width: 215px;
      height: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff !important;
      font-size: 1.1rem;
      cursor: pointer;

      :hover {
        background-image: url("/assets/imgs/page/esg/esg_btn_on.png");
      }

      & span {
        margin-left: 5px;
      }
    }
  }
  @media screen and (max-width: 991px) {
    margin-bottom: 50px;
    & img {
      width: 50%;
    }
    & div {
      width: calc(50% - 20px);

      & h2 {
        font-size: 24px;
        margin-bottom: 50px;
      }
      p {
        margin-bottom: 30px;
      }
    }
  }
  @media screen and (max-width: 767px) {
    & div {
      width: 50%;
      & h2 {
        margin-bottom: 20px;
      }
      p {
        margin-bottom: 20px;
      }
      & a {
        width: 100%;
        font-size: 16px;
        border-radius: 20px;
        span {
          display: none;
        }
      }
    }
  }
  @media screen and (max-width: 575px) {
  }
`;

export const H1Font = styled.h1`
  font-size: 40px;
  font-weight: 700;
  line-height: 1.2;
`;

export const H1FontBottom = styled.h2`
  font-size: 40px;
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 100px;
`;
